// export * as file from './user.model'
import * as user from './user.model'
import * as auth from './auth.model'
import * as document from './document.model'
export default {
  user,
  auth,
  document
}
